var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonPlain',_vm._g(_vm._b({staticClass:"list-item-button"},'ButtonPlain',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }